import {
    ChatToolName,
    chatToolRegistry,
    InferChatToolParameters,
    InferChatToolResult,
} from "tekkr-common/dist/model/chats/tools";
import { ToolInvocation } from "ai";

export type TypedToolInvocation<ToolName extends ChatToolName> = Omit<ToolInvocation, "toolName" | "args"> & {
    toolName: ToolName;
    args: InferChatToolParameters<ToolName>;
    result?: InferChatToolResult<ToolName>;
};

export function validatedToolInvocation(invocation: ToolInvocation): TypedToolInvocation<ChatToolName> {
    if (!(invocation.toolName in chatToolRegistry)) {
        throw new Error(`Unknown tool name: ${invocation.toolName}`);
    }
    return invocation as TypedToolInvocation<ChatToolName>;
}

export function isInvocationWithType<K extends ChatToolName>(
    k: K,
    invocation: TypedToolInvocation<ChatToolName>
): invocation is TypedToolInvocation<K> {
    return invocation.toolName === k;
}
